'use strict';

function SocialReferralSettings($q, settingsFactory, brandServices, userPermissions, hmapService) {
    var self = this;
    self.settings = {};
    self.tamplateSmartFields = {};
    self.userSettings = null;
    self.settingsFactory = settingsFactory;
    self.brandServices = brandServices;
    self.userPermissions = userPermissions;
    self.hmapService = hmapService;
    self.$q = $q;
    let checkSettingsRequests = {};
    self.messageTemplates = {};
    let checkMessageTemplatesRequests = {};

    self.getUserSettings = function () {
        var defer = $q.defer();

        if (self.userSettings) {
            defer.resolve(self.userSettings);
        } else {
            SocialReferralAPI.getSocialReferralUserSettings().then(function (settings) {
                self.userSettings = settings;
                defer.resolve(settings);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.isExternalManagementEnabled = function () {
        var defer = self.$q.defer();
        self.getUserSettings().then(function (settings) {
            defer.resolve(!!settings.is_external_referral_enabled);
        }, function () {
            defer.reject(null);
        });
        return defer.promise;
    };

    self.isInternalManagementEnabled = function () {
        var defer = self.$q.defer();
        self.getUserSettings().then(function (settings) {
            defer.resolve(!!settings.is_internal_referral_enabled);
        }, function () {
            defer.reject(null);
        });
        return defer.promise;
    };

    let getCachedBrandsKey = function (brandId) {
        let brandIdsCachedKey;
        if (!Array.isArray(brandId)) {
            brandIdsCachedKey = brandId;
        } else {
            //Create a cache key from the sorted array of brands
            let sortedBrandIds = brandId.sort((a, b) => a - b);
            brandIdsCachedKey = sortedBrandIds.join("-");
        }
        return brandIdsCachedKey;
    }

    self.getSettings = function (brandId) {
        var defer = self.$q.defer();
        let brandIdsCachedKey = getCachedBrandsKey(brandId);
        // Check if there is already a pending request for the same settings
        if (checkSettingsRequests[brandIdsCachedKey]) {
            return checkSettingsRequests[brandIdsCachedKey];
        }
        checkSettingsRequests[brandIdsCachedKey] = defer.promise;

        // Cache the settings for the selected brands
        if (self.settings[brandIdsCachedKey]) {
            defer.resolve(self.settings[brandIdsCachedKey]);
        } else {
            SocialReferralAPI.getSocialRefferalSettings(brandId).then(function (settings) {
                self.settings[brandIdsCachedKey] = settings;
                defer.resolve(settings);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.isExternalEnabled = function (brandId) {
        var defer = self.$q.defer();
        let brandIdsCachedKey = getCachedBrandsKey(brandId);
        if (self.settings[brandIdsCachedKey]) {
            defer.resolve(self.settings[brandIdsCachedKey].common_setting.is_external_referral_enabled);
        } else {
            self.getSettings(brandId).then(function (settings) {
                defer.resolve(!!settings.common_setting.is_external_referral_enabled);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.isInternalEnabled = function (brandId) {
        var defer = self.$q.defer();
        let brandIdsCachedKey = getCachedBrandsKey(brandId);
        if (self.settings[brandIdsCachedKey]) {
            defer.resolve(self.settings[brandIdsCachedKey].common_setting.is_internal_referral_enabled);
        } else {
            self.getSettings(brandId).then(function (settings) {
                defer.resolve(!!settings.common_setting.is_internal_referral_enabled);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.isSMSEnabled = function (brandId) {
        var defer = self.$q.defer();
        let brandIdsCachedKey = getCachedBrandsKey(brandId);
        if (self.settings[brandIdsCachedKey]) {
            defer.resolve(self.settings[brandIdsCachedKey].common_setting.is_sms_enabled);
        } else {
            self.getSettings(brandId).then(function (settings) {
                defer.resolve(!!settings.common_setting.is_sms_enabled);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.isEmailEnabled = function (brandId) {
        var defer = self.$q.defer();
        let brandIdsCachedKey = getCachedBrandsKey(brandId);
        if (self.settings[brandIdsCachedKey]) {
            defer.resolve(self.settings[brandIdsCachedKey].common_setting.is_email_enabled);
        } else {
            self.getSettings(brandId).then(function (settings) {
                defer.resolve(!!settings.common_setting.is_email_enabled);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.getInvalidBrandIds = function (brandId) {
        var defer = self.$q.defer();
        let brandIdsCachedKey = getCachedBrandsKey(brandId);
        if (self.settings[brandIdsCachedKey]) {
            defer.resolve(self.settings[brandIdsCachedKey].invalid_brand_ids);
        } else {
            self.getSettings(brandId).then(function (settings) {
                defer.resolve(settings.invalid_brand_ids);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.getMessageTemplates = function (brandId, filter, category) {
        let defer = self.$q.defer();
        let brandIdsCachedKey = getCachedBrandsKey(brandId);

        if (checkMessageTemplatesRequests[brandIdsCachedKey]) {
            return checkMessageTemplatesRequests[brandIdsCachedKey];
        }
        checkMessageTemplatesRequests[brandIdsCachedKey] = defer.promise;

        if (self.messageTemplates[brandIdsCachedKey]) {
            defer.resolve(self.messageTemplates[brandIdsCachedKey]);
        } else {
            BrandAPI.getBulkBrandsMessageTemplates(brandId, filter, category).then(function (templates) {
                self.messageTemplates[brandIdsCachedKey] = templates;
                defer.resolve(templates);
            }, function () {
                defer.reject(null);
            });
        }
        return defer.promise;
    };

    self.isEmployeeReferralListsEnabled = function (brandsIds) {

        var brandsList = brandsIds;
        var userPermission = self.userPermissions;
        var brandServices = self.brandServices;
        var defer = self.$q.defer();
        var finishedRequest = 0;

        brandsList.forEach(function (brand) {
            var serviceIsResolved = false;

            var promises = {};
            promises['policyParser'] = userPermission.getBrandPolicy(brand.brand_id);
            promises['serviceEnabled'] = brandServices.check(brandServices.SERVICES.SOCIAL_REFERRAL, brand.brand_id);

            $q.all(promises)
                .then(function (result) {

                    finishedRequest++;

                    var policyParser = result['policyParser'];
                    var serviceEnabled = result['serviceEnabled'];

                    if (policyParser.has(userPermission.PERMISSIONS.MANAGE_EMPLOYEE_REFERRAL) && serviceEnabled && !serviceIsResolved) {
                        serviceIsResolved = true;
                        defer.resolve(true)
                    }

                    if (finishedRequest === brandsList.length && !serviceIsResolved) {
                        defer.resolve(false)
                    }

                }, function (err) {

                    console.error(err);

                    finishedRequest++;
                    if (finishedRequest === brandsList.length && !serviceIsResolved) {
                        defer.resolve(false)
                    }

                });

        });

        if (brandsList.length === 0) {
            defer.resolve(false);
        }

        return defer.promise;
    };

    self.isEmployeeReferralListsOnGPEnabled = function (brandId) {

        var defer = self.$q.defer();
        var userPermission = self.userPermissions;
        var brandServices = self.brandServices;
        var promises = {};

        promises['policyParser'] = userPermission.getBrandPolicy(brandId);
        promises['gpPolicy'] = self.hmapService.loadGPPlociy(brandId);

        $q.all(promises)
            .then(function (result) {
                var policyParser = result['policyParser'];
                var gpPolicy = result['gpPolicy'];

                var activeBrandPolicy = _.find(gpPolicy.brands, function (entry) {
                    return entry.id == brandId;
                });

                var serviceEnabled = activeBrandPolicy && _.find(activeBrandPolicy.services, function (entry) {
                    return brandServices.SERVICES.SOCIAL_REFERRAL === entry.code;
                });


                if (policyParser.has(userPermission.PERMISSIONS.MANAGE_EMPLOYEE_REFERRAL) && serviceEnabled) {
                    defer.resolve(true);
                } else {
                    defer.resolve(false);
                }
            }, function () {
                defer.reject(false)
            });

        return defer.promise;
    };

    self.getTemplateSmartFields = function (category) {
        var defer = self.$q.defer();
        if (!_.isEmpty(self.tamplateSmartFields[category])) {
            defer.resolve(self.tamplateSmartFields[category]);
        } else {
            BrandAPI.getTemplateSmartFields(category)
                .then(function (smartFields) {
                    self.tamplateSmartFields[category] = smartFields.map(function (item) {
                        item.name = $filter("translate")(item.name);
                        return item;
                    });
                    defer.resolve(smartFields);
                })
                .catch(function (err) {
                    defer.reject(err);
                });
        }
        return defer.promise;
    };

    self.getTemplateSharedBrands = function (brandId, templateId) {
        var defer = self.$q.defer();
        BrandAPI.getTemplateSharedBrands(brandId, templateId).then(function (brands) {
            defer.resolve(brands);
        }).catch(function (err) {
            defer.reject(err);
        });
        return defer.promise;
    };
}

SocialReferralSettings.$inject = ['$q', 'settingsFactory', 'brandServices', 'userPermissions', 'hmapService'];

angular.module('harriApp').service('socialReferralSettings', SocialReferralSettings);
